<template>
    <tbody class="table-loader-skeleton" v-if="active">
        <tr v-for="row in rows">
            <td :colspan="cols">
                <div class="line"></div>
            </td>
        </tr>              
    </tbody>
</template>

<script>
export default {
    name: 'LoaderTableSkeleton',
    props:{
        rows:{
            type: Number,
            default: 10
        },
        cols:{
            type: Number,
            default: 6
        },
        active:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
        }
    }
}
</script>

<style lang="css">

@keyframes shine {	
  to {
    background-position: 100% 0, /* move highlight to right */ 0 0;
  }
}

.table-loader-skeleton {
    width: 100%;
    overflow-x: auto;
}

.line{
    float: left;
    width: 100%;
    height: 15px;
    display: block;
    background: linear-gradient(	  
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 80%
    ),
    #e6e6e6;
    background-repeat: repeat-y;
    background-size: 50px 500px;
    background-position: 0 0;
    animation: shine 1s infinite;	  
}
</style>